import React from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Fab, MenuItem,
    Paper,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow, TextField,
    Toolbar,
    Typography
} from "@material-ui/core";
import api from '../../services/api'
import AddIcon from "@material-ui/icons/Add"
import {withRouter} from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {DataGrid} from "@material-ui/data-grid";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const sortModel = [
    {
        field: 'card_index',
        sort: 'asc',
    },
];

class CrackListExpansionLists extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            packs: [],
            lists: [],
            filteredLists: [],
            snackbarDisplayed: false,
            snackbarMessage: '',
            filterPackId: -1,
            filterName: '',
            pageSize: 600,
            page: 1,
        };

        this.columns = [
            {
                field: 'card_index',
                headerName: 'Pack + N°',
                renderCell: (params) => {
                    return <span>{params.data.pack_fr} ({params.data.card_index})</span>;
                },
                sortComparator: (v1, v2, params1, params2) => {
                    if (!!v1 && !!v2) {
                        if (v1 === v2) {
                            return  params1.data.list_id - params2.data.list_id
                        }
                        return v1 - v2;
                    } else if (!!v1) {
                        return -1;
                    } else if (!!v2) {
                        return 1;
                    } else {
                        return params1.data.list_fr.localeCompare(params2.data.list_fr);
                    }
                },
                sortable: true,
                width: 140
            },
            {
                field: 'list_id',
                headerName: 'ID / Éditer',
                renderCell: (params) => {
                    return <span>{params.value}
                        <Button color="primary" onClick={this.editList(params.data)}><EditIcon/></Button>
                    </span>
                },
                sortable: false
            },
            {
                field: 'list_fr',
                headerName: 'FR',
                width: 280
            },
            {
                field: 'list_en_GB',
                headerName: 'UK',
                width: 280,
            },
            {
                field: 'list_en',
                headerName: 'US',
                width: 280,
            },
            {
                field: 'list_de',
                headerName: 'DE',
                width: 280,
            },
            {
                field: 'list_es',
                headerName: 'ES',
                width: 280,
            },
            {
                field: 'list_it',
                headerName: 'IT',
                width: 280,
            },
            {
                field: 'list_nl',
                headerName: 'NL',
                width: 280,
            },
        ]
    }

    componentDidMount() {
        this.updateData();
    }

    updateData() {
        Promise.all([
            api.getCrackListExpansionPacks(),
            api.getCrackListExpansionLists(),
        ]).then(res => {
            const packs = res[0];
            const lists = res[1].map(l => {
                return {
                    ...l,
                    id: l.list_id,
                }
            });
            this.setState({
                packs: packs,
                lists: lists,
                filteredLists: lists.filter(l => this.listMatchesFilters(l, this.state.filterPackId, this.state.filterName)),
            });
        });
    }

    editList = (list) => (e) => {
        this.props.history.push(`/${this.props.app.url_slug}/list/${list.list_id}`);
    };

    createList = (e) => {
        this.props.history.push(`/${this.props.app.url_slug}/create-list/${this.state.languageId}`);
    };

    deleteList = (list) => (e) => {
        if (!window.confirm('Supprimer la liste ?')) {
            return;
        }
        api.deleteCrackListExpansionList(list.list_id).then(res => {
            if (res === undefined) {
                this.displaySnackbar("Erreur lors de la suppression de la liste");
                return;
            }
            this.updateData(this.state.languageId);
        });
    }

    handleFilterPackChange = (e) => {
        this.setState({
            filterPackId: e.target.value,
            filteredLists: this.state.lists.filter(l => this.listMatchesFilters(l, parseInt(e.target.value, 10), this.state.filterName))
        });
    }

    handleFilterNameChange = (e) => {
        this.setState({
            filterName: e.target.value,
            filteredLists: this.state.lists.filter(l => this.listMatchesFilters(l, this.state.filterPackId, e.target.value))
        });
    }

    listMatchesFilters(list, packId, name) {
        return (name.length === 0 || (!!list.list_fr && list.list_fr.toLowerCase().indexOf(name.toLowerCase()) !== -1))
            && (packId === -1 || list.pack_id === packId);
    }

    onPageChange = (p) => {
        if (p.page === this.state.page) {
            return;
        }
        this.setState({page: p.page})
    }

    displaySnackbar(message) {
        this.setState({
            snackbarDisplayed: true,
            snackbarMessage: message,
        });
    }

    render() {

        if (!this.state.packs) {
            return null;
        }

        return (
            <React.Fragment>
                <Paper>
                    <Toolbar>
                        <div style={{flex: 1}}>
                            <Typography variant="h6">Listes</Typography>
                        </div>
                    </Toolbar>

                    <div style={{padding: '0 24px'}}>

                        <div style={{marginBottom: 24}}>

                            <TextField
                                style={{marginRight: 12, width: 250}}
                                select
                                value={this.state.filterPackId || -1}
                                onChange={this.handleFilterPackChange}
                                label="Pack"
                                SelectProps={{
                                    displayEmpty: true
                                }}
                            >
                                <MenuItem value={-1}>Tous les packs</MenuItem>
                                {
                                    this.state.packs.map((p, i) => <MenuItem key={p.pack_id} value={p.pack_id}>{p.pack_fr}</MenuItem>)
                                }
                            </TextField>

                        </div>

                        <div style={{marginBottom: 24}}>
                            <TextField
                                style={{marginRight: 24, width: 300}}
                                value={this.state.filterName}
                                label="Intitulé"
                                placeholder="Filtrer sur l'intitulé"
                                onChange={this.handleFilterNameChange}
                            />
                        </div>

                    </div>


                    <div style={{ display: 'flex', height: 24250 }}>
                        <div style={{ flexGrow: 1 }}>
                            <DataGrid
                                rowHeight={40}
                                autoHeight
                                sortingOrder={['asc', 'desc']}
                                sortModel={sortModel}
                                hideFooterSelectedRowCount={false}
                                columns={this.columns}
                                rows={this.state.filteredLists}
                                pageSize={this.state.pageSize}
                                page={this.state.page || 1}
                                onPageChange={this.onPageChange}
                                onPageSizeChange={this.onPageChange}
                                rowsPerPageOptions={[50, 100]}
                            />
                        </div>
                    </div>


                </Paper>

                <Fab
                    color="primary"
                    style={{
                        position: 'fixed',
                        bottom: 24,
                        right: 24,
                    }}
                    onClick={this.createList}
                >
                    <AddIcon />
                </Fab>

                <Snackbar
                    open={this.state.snackbarDisplayed}
                    message={this.state.snackbarMessage}
                    action={
                        <Button color="secondary" size="small" onClick={() => this.setState({snackbarDisplayed: false})}>
                            OK
                        </Button>
                    }
                    onClose={() => this.setState({snackbarDisplayed: false})}
                    autoHideDuration={3000}
                />

            </React.Fragment>
        );
    }
}

CrackListExpansionLists.propTypes = {
    app: PropTypes.object.isRequired,
};

CrackListExpansionLists.defaultProps = {};

export default withRouter(CrackListExpansionLists);